import React, { useContext, useEffect, useState } from 'react'
import { PATH_URL } from 'src/helpers'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../contextAPI'
import { QuizType } from 'src/pages/shared'

interface IQuizProgressBarProps {
  quizType?: QuizType
}

export const QuizProgressBar = ({ quizType }: IQuizProgressBarProps) => {
  const { screen, quizProgressPercent, setQuizProgressPercent } = useContext(QuizQuestionContext)
  const [percentage, setPercentage] = useState(quizProgressPercent)

  const setPercentageForScreen = (screen: SCREEN_QUIZ_QUESTION | undefined) => {
    switch (screen) {
      case SCREEN_QUIZ_QUESTION.NEW_COLOR_PALETTE_PAGE:
        setPercentage(15)
        setQuizProgressPercent(15)
        break
      case SCREEN_QUIZ_QUESTION.NEW_AVAILABILITY_PAGE:
        setPercentage(30)
        setQuizProgressPercent(30)
        break
      case SCREEN_QUIZ_QUESTION.YOUR_DETAILS:
        setPercentage(45)
        setQuizProgressPercent(45)
        break
      case SCREEN_QUIZ_QUESTION.PLANNING_STAGE:
        setPercentage(60)
        setQuizProgressPercent(60)
        break
      case SCREEN_QUIZ_QUESTION.GUEST_COUNT:
        setPercentage(75)
        setQuizProgressPercent(75)
        break
      case SCREEN_QUIZ_QUESTION.NEW_BUDGET_PAGE:
        setPercentage(90)
        setQuizProgressPercent(90)
        break
      case SCREEN_QUIZ_QUESTION.ESSENTIALS_COLLECTION_PAGE:
        setPercentage(90)
        setQuizProgressPercent(90)
        break
      case SCREEN_QUIZ_QUESTION.COUPLE_INFO:
        setPercentage(100)
        setQuizProgressPercent(100)
        break
      default:
        setPercentage(100)
        setQuizProgressPercent(100)
        break
    }
  }

  const PINTEREST_FLOW_PATH = [
    PATH_URL.PINTEREST_AVAILABILITY,
    PATH_URL.YOUR_DETAILS,
    PATH_URL.NEW_BUDGET_PAGE,
    PATH_URL.PINTEREST_LINK_YOUR_BOARD,
    PATH_URL.PINTEREST_BOARD,
    PATH_URL.IMPORT_PINS,
    PATH_URL.NEW_COLOR_PALETTE_PAGE,
    PATH_URL.PLANNING_STAGE,
    PATH_URL.GUEST_COUNT,
    PATH_URL.CONTACT_INFO,
  ]

  const setPercentageForPath = (pathname: string) => {
    const pathIndex = PINTEREST_FLOW_PATH.indexOf(pathname || PATH_URL.CONTACT_INFO)
    const percentage = Math.round((pathIndex / PINTEREST_FLOW_PATH.length) * 100)
    setPercentage(percentage)
    setQuizProgressPercent(percentage)
  }

  const PINTEREST_FLOW_SCREEN = [
    SCREEN_QUIZ_QUESTION.PINTEREST_AVAILABILITY,
    SCREEN_QUIZ_QUESTION.YOUR_DETAILS,
    SCREEN_QUIZ_QUESTION.NEW_BUDGET_PAGE,
    SCREEN_QUIZ_QUESTION.PINTEREST_LINK_YOUR_BOARD,
    SCREEN_QUIZ_QUESTION.PINTEREST_BOARD,
    SCREEN_QUIZ_QUESTION.IMPORT_PINS,
    SCREEN_QUIZ_QUESTION.NEW_COLOR_PALETTE_PAGE,
    SCREEN_QUIZ_QUESTION.PLANNING_STAGE,
    SCREEN_QUIZ_QUESTION.GUEST_COUNT,
    SCREEN_QUIZ_QUESTION.CONTACT_INFO,
  ]

  const setPercentageForScreenOfPinterestFlow = (screen: SCREEN_QUIZ_QUESTION | undefined) => {
    const screenIndex = PINTEREST_FLOW_SCREEN.indexOf(screen || SCREEN_QUIZ_QUESTION.CONTACT_INFO)
    const percentage = Math.round((screenIndex / PINTEREST_FLOW_SCREEN.length) * 100)
    setPercentage(percentage)
    setQuizProgressPercent(percentage)
  }

  const setPercentageForPathOfPinterestFlow = (pathname: string) => {
    switch (pathname) {
      case PATH_URL.PINTEREST_AVAILABILITY:
        setPercentage(13)
        setQuizProgressPercent(13)
        break
      case PATH_URL.YOUR_DETAILS:
        setPercentage(25)
        setQuizProgressPercent(25)
        break
      case PATH_URL.NEW_BUDGET_PAGE:
        setPercentage(38)
        setQuizProgressPercent(38)
        break
      case PATH_URL.PINTEREST_LINK_YOUR_BOARD:
        setPercentage(50)
        setQuizProgressPercent(50)
        break
      case PATH_URL.NEW_COLOR_PALETTE_PAGE:
        setPercentage(63)
        setQuizProgressPercent(63)
        break
      case PATH_URL.PLANNING_STAGE:
        setPercentage(75)
        setQuizProgressPercent(75)
        break
      case PATH_URL.GUEST_COUNT:
        setPercentage(88)
        setQuizProgressPercent(88)
        break
      default:
        setPercentage(100)
        setQuizProgressPercent(100)
        break
    }
  }

  useEffect(() => {
    if (quizType === QuizType.PINTEREST) {
      setPercentageForScreenOfPinterestFlow(screen)
    } else {
      setPercentageForScreen(screen)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screen])

  useEffect(() => {
    if (quizType === QuizType.PINTEREST) {
      setPercentageForPathOfPinterestFlow(location.pathname)
    } else {
      setPercentageForPath(location.pathname)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  return (
    <>
      <div className={'quiz-progress-bar'}>
        <div className="progress-percentage" style={{ width: `${percentage}%` }}></div>
      </div>
    </>
  )
}
